import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import { ANALYTICS } from "../../constants";

const StacksTableRowActionsCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <DropdownMenuEllipsis tooltip="Stack actions">
        <DropdownMenuItem
          analyticsTitle="Settings clicked"
          href={`/stack/${stack.id}/settings`}
          {...ANALYTICS}
        >
          Settings
        </DropdownMenuItem>
      </DropdownMenuEllipsis>
    </TableSimpleCell>
  );
};

export default StacksTableRowActionsCell;
